import { Seo } from "@/components/Seo";
import { MdxBody } from "@/components/MdxBody";
import { now } from "@/lib/content/load";
import { headingText } from "@/lib/heading";

export function NowPage() {
  const record = now[0];

  return (
    <>
      <Seo
        title="Now"
        description={record?.meta.seoDescription ?? "What Jay van Zyl is working on now."}
        path="/now"
      />
      <article className="wrap section now-page" style={{ paddingTop: "4.5rem" }}>
        <p className="eyebrow">Now</p>
        <h1>{headingText(record?.meta.title ?? "Now")}</h1>
        {record ? (
          <>
            <MdxBody Component={record.Component} />
          </>
        ) : (
          <p>Nothing posted yet.</p>
        )}
      </article>
    </>
  );
}
